"use client";

import React from "react";
import PopoverPositionContext from "./context";
import type { PopoverPositionProviderProps } from "./types";

function PopoverPositionProvider({
  children,
  ...props
}: PopoverPositionProviderProps) {
  const triggerRef = React.useRef<HTMLElement>(null);
  const contentRef = React.useRef<HTMLElement>(null);

  const context = React.useMemo(
    () => ({
      triggerRef,
      contentRef,
    }),
    [],
  );

  return (
    <PopoverPositionContext.Provider value={context} {...props}>
      {children}
    </PopoverPositionContext.Provider>
  );
}

export default PopoverPositionProvider;
